import { o } from "../../nexus-client-4D0Jw00_.js";
const r = o.promo.up;
export {
  r as promoUp
};
/*                             */
